export const SUBSCRIBE              = 'SUBSCRIBE';
export const SUBSCRIBE_FULFILLED    = 'SUBSCRIBE_FULFILLED';
export const SUBSCRIBE_PENDING      = 'SUBSCRIBE_PENDING';
export const SUBSCRIBE_REJECTED     = 'SUBSCRIBE_REJECTED';

export const UNSUBSCRIBE            = 'UNSUBSCRIBE';
export const UNSUBSCRIBE_FULFILLED  = 'UNSUBSCRIBE_FULFILLED';
export const UNSUBSCRIBE_PENDING    = 'UNSUBSCRIBE_PENDING';
export const UNSUBSCRIBE_REJECTED   = 'UNSUBSCRIBE_REJECTED';